import { rem } from "polished";
import styled, { css } from "styled-components";

import useProperties from "@/hooks/use-properties";

import { ColorLabels, useInvertedColor } from "../utils/use-color";

export const FooterWrapper = styled.footer`
  ${() => {
    const properties = useProperties();
    const backgroundColor = properties.colors[ColorLabels.BACKGROUND];
    const color = useInvertedColor(backgroundColor);

    return css`
      display: grid;
      place-content: center center;
      background-color: ${backgroundColor};
      height: ${rem(80)};
      width: 100%;

      .logo-label {
        color: ${color};
        opacity: 0.6;
      }
    `;
  }}
`;
